<template>
  <div>
    <notification-template
      :large="large"
      :hash="notification.id"
      :urlProfilePhoto="teacher.urlProfilePhoto"
    >
      <template v-slot:header>
        {{$t('notifications.youHaveCanceledLesson')}}
      </template>
      <template v-slot:actions>
        <div>
          {{$t('notifications.lessonWithTeacher')}}
          <router-link :to="`/teachers/${teacher.slug}`" class="font-medium">
            {{ teacher.name }}
          </router-link>
        </div>
        <button class="flex rounded-sm p-2 text-orange-academy-300 mt-2 uppercase
          border opacity-60 hover:opacity-100 border-orange-academy-300 items-center"
          @click="contact(user, teacher.user)"
          >
            <message-icon class="w-5"/>
            <span class="pl-3">
            {{$t('notifications.sendMessage')}} {{ teacher.name }}
            </span>
        </button>
      </template>
    </notification-template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MessageIcon from '@/components/graphics/MessageIcon.vue';
import NotificationTemplate from './NotificationTemplate.vue';
import StreamFunctionsMixin from '../../mixins/StreamFunctionsMixin';

export default {
  props: {
    notification: {
      type: Object,
      default: () => {},
    },
    large: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      lesson: { ...this.notification.data.lesson },
      teacher: { ...this.notification.data.teacher },
      slot: { ...this.notification.data.slot },
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },
  components: {
    MessageIcon,
    NotificationTemplate,
  },
  mixins: [StreamFunctionsMixin],
};
</script>
